import { GatewayQuestionnaire } from "@conformite/gateway";

type Slug = GatewayQuestionnaire.QuestionnaireSlug;

const IAS_ASSUJETTI_SLUGS: readonly Slug[] = [
  "cq_honorabilite",
  "cq_capacite_pro_ias",
  "cq_formation_continue_ias",
];

const IOBSP_ASSUJETTI_SLUGS: readonly Slug[] = [
  "cq_capacite_pro_iobsp",
  "cq_formation_continue_iobsp",
];

const PARTICIPATION_ORDER = 1;
const LISTE_CORRESPOND_ORDER = 2;

export function getSharedAssujettiAnswerKey(
  slug: string | undefined,
  order: number
): string | null {
  if (!slug) return null;

  const isIas = (IAS_ASSUJETTI_SLUGS as readonly string[]).includes(slug);
  const isIobsp = (IOBSP_ASSUJETTI_SLUGS as readonly string[]).includes(slug);
  if (!isIas && !isIobsp) return null;

  if (order === PARTICIPATION_ORDER) {
    return `participation:${isIas ? "IAS" : "IOBSP"}`;
  }
  if (order === LISTE_CORRESPOND_ORDER) {
    return "liste-correspond";
  }
  return null;
}
